<div class="header-container">
  <h2 class="header-title">Data Source Images</h2>
  <span nz-icon nzType="warning" nzTheme="outline" style="font-size: 20px"
        nz-tooltip="The file must be in PNG format. The file size must not exceed 200 KB.
        The file name must exactly match the supplier_system_partner_id followed by the .png extension.
        (Example: pas-de-123-123.png). After uploading a new logo, the updated version will become visible after a short delay because of caching."
  ></span>
</div>
<div class="data-sources">
  <nz-skeleton  [nzActive]="true" [nzLoading]="loading" style="width: 100%;"></nz-skeleton>
  @for (dataSource of dataSources | sortBy: 'supplier_system_partner_name'; track dataSources){
    <data-source [dataSource]="dataSource" />
  }
</div>
